import { authFetch } from '@/services/apiClient'

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
  message?: string
}

export interface EnrollmentResult {
  enrollment_id: number
  course_id: number
  batch_id: number | null
  status: string
  enrolled_at: string
  completed_at: string | null
  progress_percent: number
  enrolled_by_company_id?: number | null
  enrolled_by_company_name?: string | null
  can_review?: boolean   // รีวิวได้แล้วหรือยัง — ออนไลน์: เรียนจบ / Onsite: หลังจบรุ่น (backend ตัดสิน)
  course: {
    course_id: number
    title: string
    slug: string
    thumbnail_url: string | null
    course_format: string
  }
  batch: {
    batch_id: number
    batch_name: string
    start_date: string
    venue_name: string | null
  } | null
}

async function parseJson<T>(res: Response): Promise<ApiResponse<T>> {
  try {
    return await res.json()
  } catch {
    return { success: false, error: 'เชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ' }
  }
}

export const getMyEnrollments = async (): Promise<EnrollmentResult[]> => {
  const res = await authFetch('/my-enrollments')
  const json = await parseJson<EnrollmentResult[]>(res)
  if (!json.success || !json.data) throw new Error(json.error || json.message || 'โหลดคอร์สของฉันไม่สำเร็จ')
  return json.data
}
